import {
  IExemption,
  IContract,
  IExemptionGridCollums,
} from 'interfaces/Exemption';
import { isAfter, isAfterNow } from 'utils/date';

export const getAllContractsWithMainExemption = (
  contracts: IContract[],
): IExemptionGridCollums[] =>
  contracts.map((contract) => getMainExemptionByContract(contract));

const getMainExemptionByContract = (
  contract: IContract,
): IExemptionGridCollums => {
  const { exemptions } = contract;

  const contractProps = {
    cpfOwner: contract.cpfOwner,
    originalId: contract.originalId,
    currentAging: contract.currentAging,
    debtAmount:
      contract.invoicesTotalBilledAmount - contract.invoicesTotalPayedAmount,
  };

  let greatestFinalDate = '0' as string | Date;
  let mainExemptionIndex = 0;
  exemptions.forEach((e, index) => {
    const currentFinalDate = e.finalDate;

    if (isAfter(currentFinalDate, greatestFinalDate)) {
      mainExemptionIndex = index;
      greatestFinalDate = currentFinalDate;
    }
  });

  const mainExemption = getExemptionParsed(exemptions[mainExemptionIndex]);

  return {
    ...contractProps,
    ...mainExemption,
  } as IExemptionGridCollums;
};

const getExemptionParsed = (
  exemption: IExemption,
): { [key: string]: unknown } => ({
  _id: exemption._id,
  id: exemption._id,
  'exemptions.status': isAfterNow(exemption.finalDate) ? 'active' : 'inactive',
  'exemptions.origin': exemption.origin,
  'exemptions.initialDate': exemption.initialDate,
  'exemptions.finalDate': exemption.finalDate,
  'exemptions.motive': exemption.motive,
  'exemptions.hasServicesCategory': exemption.servicesCategories.length > 0,
  'exemptions.servicesCategories': exemption.servicesCategories,
  'exemptions.note': exemption.note,
});
